import CadenceControlModal from './cadenceControlModal.view';

export default CadenceControlModal;
